export default __webpack_public_path__ + "static/media/4air-b.a5be5a49.png";